/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchSessionV2 } from './SearchSessionV2';
import {
    SearchSessionV2FromJSON,
    SearchSessionV2FromJSONTyped,
    SearchSessionV2ToJSON,
    SearchSessionV2ToJSONTyped,
} from './SearchSessionV2';

/**
 * A collection of search sessions
 * @export
 * @interface SearchSessionCollection
 */
export interface SearchSessionCollection {
    /**
     * 
     * @type {Array<SearchSessionV2>}
     * @memberof SearchSessionCollection
     */
    items?: Array<SearchSessionV2>;
}

/**
 * Check if a given object implements the SearchSessionCollection interface.
 */
export function instanceOfSearchSessionCollection(value: object): value is SearchSessionCollection {
    return true;
}

export function SearchSessionCollectionFromJSON(json: any): SearchSessionCollection {
    return SearchSessionCollectionFromJSONTyped(json, false);
}

export function SearchSessionCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSessionCollection {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SearchSessionV2FromJSON)),
    };
}

export function SearchSessionCollectionToJSON(json: any): SearchSessionCollection {
    return SearchSessionCollectionToJSONTyped(json, false);
}

export function SearchSessionCollectionToJSONTyped(value?: SearchSessionCollection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SearchSessionV2ToJSON)),
    };
}

